import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './more_products.scss'
import { __ } from '@wordpress/i18n';
var plugin_url = nxtext_ajax_object.nxtex_url;

var activateTheme = nxtext_ajax_object?.dashData?.nexterThemeActive || false;
var nexterThemeDet = nxtext_ajax_object?.dashData?.nexterThemeDet || false;

import { nxtdash_install_plugin, nxtdash_install_theme  } from '../../apicall';

const proData = [
    {
        key : 'nexter-theme',
        name: __('Nexter WP Theme', 'nexter-extension'),
        url: 'https://nexterwp.com/nexter-theme/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
        img: plugin_url + 'assets/images/nexter-theme-logo.png',
    },
    {
        key : 'nexter-extension',
        name: __('Nexter Extension', 'nexter-extension'),
        url: 'https://nexterwp.com/nexter-extension/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
        img: plugin_url + 'assets/svg/products/nexter-extension.svg',
    },
    {
        key : 'the-plus-addons-for-block-editor',
        name: __('Nexter Blocks', 'nexter-extension'),
        url: 'https://nexterwp.com/nexter-blocks/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
        img: plugin_url + 'assets/svg/products/nexter-blocks.svg',
    },
    {
        key : 'the-plus-addons-for-elementor-page-builder',
        name: __('The Plus Addons for Elementor', 'nexter-extension'),
        url: 'https://theplusaddons.com/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
        img: plugin_url + 'assets/svg/products/tpae.png',
    },
    {
        key : 'wdesignkit',
        name: __('WDesignKit – Templates, Widgets, Cloud Storage & More', 'nexter-extension'),
        url: 'https://wdesignkit.com/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
        img: plugin_url + 'assets/svg/products/wdesignkit.svg',
    },
    {
        key : 'uichemy',
        name: __('UiChemy - Figma to WordPress Convertor', 'nexter-extension'),
        url: 'https://uichemy.com/?utm_source=wpbackend&utm_medium=blocks&utm_campaign=nextersettings',
        img: plugin_url + 'assets/svg/products/uichemy.svg',
    },
];

const MoreProducts = () => {

    const Navigate = useNavigate();

    useEffect(() => {
        if ((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_plugin_ads == 'on') {
            Navigate('/');
        }
    }, [nxtext_ajax_object?.dashData?.whiteLabel?.nxt_plugin_ads]);

    const [nexterThemeIntall, setNexterThemeIntall] = useState(nxtext_ajax_object?.dashData?.nexterThemeIntall || false);

    const [nxtOtherPluginInstall, setNxtOtherPluginInstall] = useState(() => ({
        'the-plus-addons-for-block-editor': {'active': nxtext_ajax_object?.dashData?.tpgbactivate || false, 'install' : nxtext_ajax_object.dashData.nexterBlock || false},
        'the-plus-addons-for-elementor-page-builder': {'active': nxtext_ajax_object?.dashData?.tpaeactive || false, 'install' : nxtext_ajax_object?.dashData?.tpaeAddon || false},
        'nexter-extension': {'active': nxtext_ajax_object?.dashData?.extensionactivate || false, 'install' : nxtext_ajax_object.dashData.extensioninstall || false},
        'wdesignkit': {'active': nxtext_ajax_object?.dashData?.wdkactive || false, 'install' : nxtext_ajax_object.dashData.wdkPlugin || false},
        'uichemy': {'active': nxtext_ajax_object?.dashData?.uichemyactive || false, 'install' : nxtext_ajax_object.dashData.uichemy || false},
    }));

    const installNxtTheme = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('action', 'nexter_ext_theme_install');
        formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
        formData.append('slug', 'nexter');
        
        nxtdash_install_theme(e, formData, setNexterThemeIntall);
    }

    const installNxtPlugin = (e, slug) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('action', 'nexter_ext_plugin_install');
        formData.append('nexter_nonce', nxtext_ajax_object.ajax_nonce);
        formData.append('slug', slug);
        
        nxtdash_install_plugin(e, formData, slug, setNxtOtherPluginInstall, 'more_products');
    }

    return (
        <div className='nxtext_products_cover_main nxtext_main_container'>
            <div className='nxtext_section_heading_cover'>
                <h3 className='nxtext_primary_heading'>{__('More Products', 'nexter-extension')}</h3>

                <div className='nxtext_head_tgl_btn_grp'>
                    <a href='https://posimyth.com/' target='_blank' rel="nofollow noopener noreferrer"  className='nxtext_blue_common_btn'>{__('Visit Official Website', 'nexter-extension')}</a>
                </div>
            </div>
            <div className='nxtext_products_box_cover_main'>
                <div className='nxtext_main_container'>
                    {
                        proData.map((obj,index) => (
                            <div className='nxtext_product_box' key={index.toString()}>
                                <div className='nxtext_product_logo_title_cover'>
                                    <div className='nxt_product_logo'>
                                        <img src={obj.img} draggable={false} />
                                    </div>
                                    <h4 className='nxtext_product_name nxtext_secondary_heading'>{obj.name}</h4>
                                </div>
                                <div className='nxtext-more-product-install'>
                                    { obj.key == 'nexter-theme' &&
                                        <>
                                            { (!activateTheme && !nexterThemeIntall) && 
                                                <button className="nxtext-install-btn" onClick={(e)=>{ installNxtTheme(e)}}>{__('Install', 'nexter-extension')}</button>
                                            }
                                            { (!activateTheme && (nexterThemeIntall || nexterThemeIntall == "available")) && 
                                            <a className="nxtext-install-btn" href={nexterThemeDet} target='_blank'>{__('Activate', 'nexter-extension')}</a> }

                                            { (activateTheme && nexterThemeIntall) &&
                                                <button className="nxtext-install-btn nxtext-activated">{__('Activated', 'nexter-extension')}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14"><path fill="#14c38e" d="M6.473.014C5.458.109 4.686.326 3.843.75c-1.112.555-2.141 1.499-2.817 2.582-.49.783-.846 1.792-.991 2.804-.047.323-.047 1.401 0 1.724.115.807.328 1.513.662 2.188.375.766.745 1.28 1.353 1.89a6.5 6.5 0 0 0 1.864 1.338 6.2 6.2 0 0 0 1.368.507 6.94 6.94 0 0 0 4.079-.195c.41-.145 1.117-.5 1.478-.741a7.5 7.5 0 0 0 2.105-2.156c.197-.309.515-.965.643-1.33a6.94 6.94 0 0 0-.314-5.452 6.7 6.7 0 0 0-1.254-1.772A6.7 6.7 0 0 0 10.073.72 6.7 6.7 0 0 0 7.609.022 9 9 0 0 0 6.473.014"/><path fill="#fff" d="M9.678 4.713c-.037.016-.966.93-2.064 2.033l-2 2.003-.744-.746c-.805-.804-.81-.807-1.043-.762a.46.46 0 0 0-.311.312c-.045.238-.061.22.958 1.241S5.47 9.8 5.71 9.756c.09-.016.349-.264 2.3-2.218 1.596-1.6 2.203-2.226 2.224-2.292a.43.43 0 0 0-.166-.487.53.53 0 0 0-.39-.045"/></svg>
                                                </button>
                                            }
                                        </>
                                    }
                                    { obj.key != 'nexter-theme' &&
                                        <>
                                            { nxtOtherPluginInstall[obj.key].install ?
                                                <button className="nxtext-install-btn nxtext-activated">{__('Activated', 'nexter-extension')}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14"><path fill="#14c38e" d="M6.473.014C5.458.109 4.686.326 3.843.75c-1.112.555-2.141 1.499-2.817 2.582-.49.783-.846 1.792-.991 2.804-.047.323-.047 1.401 0 1.724.115.807.328 1.513.662 2.188.375.766.745 1.28 1.353 1.89a6.5 6.5 0 0 0 1.864 1.338 6.2 6.2 0 0 0 1.368.507 6.94 6.94 0 0 0 4.079-.195c.41-.145 1.117-.5 1.478-.741a7.5 7.5 0 0 0 2.105-2.156c.197-.309.515-.965.643-1.33a6.94 6.94 0 0 0-.314-5.452 6.7 6.7 0 0 0-1.254-1.772A6.7 6.7 0 0 0 10.073.72 6.7 6.7 0 0 0 7.609.022 9 9 0 0 0 6.473.014"/><path fill="#fff" d="M9.678 4.713c-.037.016-.966.93-2.064 2.033l-2 2.003-.744-.746c-.805-.804-.81-.807-1.043-.762a.46.46 0 0 0-.311.312c-.045.238-.061.22.958 1.241S5.47 9.8 5.71 9.756c.09-.016.349-.264 2.3-2.218 1.596-1.6 2.203-2.226 2.224-2.292a.43.43 0 0 0-.166-.487.53.53 0 0 0-.39-.045"/></svg>
                                                </button>
                                                :
                                                <button className="nxtext-install-btn" onClick={(e) => {installNxtPlugin(e, obj.key)}}>{nxtOtherPluginInstall[obj.key].active ? __('Activate', 'nexter-extension') : __('Install', 'nexter-extension')}</button>
                                            }
                                        </>
                                    }
                                    <a target='_blank' rel="nofollow noopener noreferrer"  href={obj.url} className='nxtext_primary_btn'>{__('Learn More', 'nexter-extension')}</a>
                                </div>
                            </div>
                        ))
                    }

                </div>
            </div>
        </div>
    )
}

export default MoreProducts